var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShamo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE6\xB2\x99\xE6\xBC\xA0 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.614387 12.6322C0.504316 12.7844 0.488822 12.9854 0.574274 13.1527C0.659726 13.3199 0.831707 13.4252 1.01953 13.4252H14.9667C15.1513 13.4252 15.3208 13.3235 15.4078 13.1607C15.4947 12.998 15.4849 12.8005 15.3823 12.6471C14.9558 12.0098 14.5503 11.4871 14.1652 11.0878C13.7846 10.6931 13.3986 10.392 13.0063 10.2355L13.0063 10.2355C11.0959 9.47358 9.90427 8.38611 9.46903 6.90349C9.26599 6.21139 8.86403 5.64557 8.15895 5.54589C7.5301 5.45698 6.84622 5.78072 6.16366 6.28439C4.76646 7.31541 2.9135 9.45326 0.614387 12.6322Z",
    fill: "#E0AB52",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.06814 6.03827C8.48998 6.08843 8.79254 6.40897 8.97593 6.99952L8.98939 7.0443C9.48329 8.72726 10.8286 9.90531 12.8211 10.6999C13.2369 10.8658 13.71 11.2759 14.2404 11.9302L14.3225 12.0329L14.4054 12.1393L14.4473 12.194L14.5317 12.3062L14.5741 12.3637L14.6598 12.4818C14.7173 12.5618 14.7751 12.6442 14.8339 12.7294L14.9222 12.8589L14.9667 12.9251L5.43628 12.9254C7.43538 12.322 8.96516 10.1291 7.91655 8.63367C7.29444 7.74668 7.2641 7.14621 7.44529 6.72817L7.46511 6.68473C7.49251 6.62784 7.52383 6.57462 7.55809 6.52446L7.58415 6.48739L7.5976 6.46941L7.62525 6.43417L7.65364 6.40004L7.68276 6.36701L7.71249 6.3352L7.74283 6.30449C7.74784 6.29935 7.75298 6.29433 7.75812 6.28944L7.78895 6.26008L7.82015 6.23194L7.86725 6.19132L7.89869 6.16551L7.94567 6.12844L8.00758 6.08195L8.06814 6.03827Z",
    fill: "#FFCF7E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShamo);
export default __webpack_public_path__ + "static/media/shamo.2ce9c205d3f44a7b5617cd79df9845b5.svg";
export { ForwardRef as ReactComponent };